import { useContext } from "react";
import { KycFlowUIContext } from "../modules/kyc-v2/components/compliance/KycFlowUIContext";

export const useKycFlowUIContext = () => useContext(KycFlowUIContext);
